export default __webpack_public_path__ + "static/media/pnmLogo.328d8144.png";